export const FETCH_CART_ITEMS = 'fetchCartItems';
export const ADD_TO_CART = 'addToCart';
export const REMOVE_FROM_CART = 'removeFromCart';
export const EMPTY_CART = 'emptyCart';